import styled, { useTheme } from 'styled-components'
import Modal from '@/components/common/modals/Modal'
import { Typo, TypoVariant } from '@/components/common/typography'

interface CartErrorModalProps {
  onConfirm: () => void
  isShow: boolean
}
export const CartErrorModal = ({ onConfirm, isShow }: CartErrorModalProps) => {
  const { color } = useTheme()

  return (
    <Modal open={isShow}>
      <Modal.Content>
        <Modal.Title>
          <Typo variant={TypoVariant.Heading6Bold}>
            구매불가 상품이 있어요
            <br /> 옵션 및 수량을 다시 확인해주세요.
          </Typo>
        </Modal.Title>
      </Modal.Content>
      <Modal.Footer>
        <ModalButton className="ok" onClick={onConfirm}>
          <Typo variant={TypoVariant.Body1Bold} color={color.grayWhite}>
            확인
          </Typo>
        </ModalButton>
      </Modal.Footer>
    </Modal>
  )
}

const ModalButton = styled.button`
  flex: 1;
  border-radius: 0.8rem;
  border: 0.1rem solid;
  padding: 1.3rem 1.6rem;
  cursor: pointer;
  width: 100%;

  &.ok {
    border-color: ${({ theme }) => theme.color.blue500};
    background-color: ${({ theme }) => theme.color.blue500};
  }
`
